import { useState } from 'react';
import { CabeceraPagina } from '../../components/Armazon';
import { Aviso, Boton, Cargando, Tarjeta, Vacio } from '../../components/ui';
import { api, qs } from '../../lib/api';
import { ROL_ETIQUETA, fechaHora } from '../../lib/formato';
import { useDatos } from '../../lib/sesion';
import type { Rol } from '../../lib/tipos';

interface Registro {
  id: string;
  entityType: string;
  entityId: string | null;
  action: string;
  ip: string | null;
  createdAt: string;
  actorName: string | null;
  actorRole: Rol | null;
  afterJson: unknown;
}

const ENTIDADES = ['', 'VisitRequest', 'KitchenPlan', 'User', 'Client', 'Setting', 'ImportBatch'];

export function Auditoria() {
  const [entidad, setEntidad] = useState('');
  const [pagina, setPagina] = useState(1);

  const { datos, cargando, error } = useDatos(
    (s) => api.get<{ rows: Registro[] }>(`/admin/audit${qs({ entityType: entidad, page: pagina, pageSize: 50 })}`, s),
    [entidad, pagina],
  );

  return (
    <>
      <CabeceraPagina
        titulo="Auditoría"
      />

      <div className="pila">
        <div className="fila">
          <div className="campo" style={{ maxWidth: 260 }}>
            <label>Tipo de registro</label>
            <select
              value={entidad}
              onChange={(e) => {
                setPagina(1);
                setEntidad(e.target.value);
              }}
            >
              {ENTIDADES.map((e) => (
                <option key={e} value={e}>
                  {e || 'Todos'}
                </option>
              ))}
            </select>
          </div>
        </div>

        {error && <Aviso tono="error">{error}</Aviso>}

        <Tarjeta sinRelleno>
          {cargando ? (
            <Cargando />
          ) : datos?.rows.length ? (
            <>
              <table className="tabla">
                <thead>
                  <tr>
                    <th>Cuándo</th>
                    <th>Quién</th>
                    <th>Qué</th>
                    <th>Sobre</th>
                    <th>Origen</th>
                  </tr>
                </thead>
                <tbody>
                  {datos.rows.map((r) => (
                    <tr key={r.id}>
                      <td className="sutil dato" style={{ fontSize: 12.5 }}>
                        {fechaHora(r.createdAt)}
                      </td>
                      <td>
                        <div>{r.actorName ?? 'Sistema'}</div>
                        <div className="sutil">{r.actorRole ? ROL_ETIQUETA[r.actorRole] : ''}</div>
                      </td>
                      <td>{r.action}</td>
                      <td className="sutil">
                        {r.entityType}
                        {r.entityId ? ` · ${r.entityId.slice(0, 8)}` : ''}
                      </td>
                      <td className="sutil dato" style={{ fontSize: 12 }}>
                        {r.ip ?? '—'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="fila" style={{ justifyContent: 'flex-end', padding: '12px 24px' }}>
                <Boton variante="secundario" tam="s" disabled={pagina <= 1} onClick={() => setPagina(pagina - 1)}>
                  Anterior
                </Boton>
                <Boton
                  variante="secundario"
                  tam="s"
                  disabled={(datos?.rows.length ?? 0) < 50}
                  onClick={() => setPagina(pagina + 1)}
                >
                  Siguiente
                </Boton>
              </div>
            </>
          ) : (
            <Vacio titulo="Sin registros para este filtro" />
          )}
        </Tarjeta>
      </div>
    </>
  );
}
